import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { CustomError } from "../errors";
import { PackagingAndLabel, RequestPackagingAndLabel } from "./types";

const useProcessingRequestLabelsPackagingsApi = () => {
  const requesturl = "/processing_requests";
  const baseurl = "/labels_packagings";

  const api = useApi();

  const useProcessingRequestLabelsPackagings = useCallback(
    (processingRequestId: string) => {
      const url = `${requesturl}/${processingRequestId + baseurl}`;
      const result = useQuery<Paginated<RequestPackagingAndLabel>, CustomError>({
        queryKey: [url],
        queryFn: ({ signal }) => api.get<Paginated<RequestPackagingAndLabel>>({ url, signal }),
      });
      return { ...result, error: result.error ?? undefined };
    },
    [api]
  );

  const searchLabelsAndPackagings = useCallback(
    async (query: PaginationQuery) => {
      const url = buildUrl(baseurl, query);
      const data = await api.get<Paginated<PackagingAndLabel>>({ url });
      return data.items;
    },
    [api]
  );

  return {
    useProcessingRequestLabelsPackagings,
    searchLabelsAndPackagings,
  };
};

export default useProcessingRequestLabelsPackagingsApi;
